(function (window, document, undefined) {
  "use strict";

  let Vue = window.Vue || false,
    externalArticle,
    logger;

  const _init = function () {
    try {
      logger = new window.RussMedia.Utils.Logger("[external posts] ") || {
        log: function () {},
      };
    } catch (e) {
      logger = { log: function () {} };
    }

    if (!Vue) {
      logger.log("_init: No Vue!");
      return;
    } else {
      logger.log("Load Vue component.");
    }

    let externalPostData = parsePostData();
    if (!externalPostData) {
      logger.log("_init: No post data.");
      return;
    }

    let showPost = externalPostData.content.data.post;
    let shorten = false;
    let isFree = true;
    let calculatedPosition = 3;
    if (externalPostData.premium_content) {
      shorten = true;
      isFree = false;
      let isVNComment =
        showPost.isComment && externalPostData.provider === "vn";
      const paywallPosition = externalPostData.paywall_position || 0;
      calculatedPosition = calculatePaywallPosition(
        paywallPosition,
        showPost.blocks,
        isVNComment
      );
    }

    const interactionStats = externalPostData.interaction_stats ?? {};

    let displayInteractionBar = true;

    // Hide interaction bar for native articles.
    if (externalPostData.is_native) {
      displayInteractionBar = false;
    }

    externalArticle = Vue.createApp({
      components: {
        VnArticle: window["@russmedia-frontend/nordstern-article"].VnArticle,
        NeueArticle:
          window["@russmedia-frontend/nordstern-article"].NeueArticle,
      },
      data() {
        return {
          isFree,
          interactionStats,
          displayInteractionBar,
          shortenContent: shorten,
          post: showPost,
          blocksBeforePaywall: calculatedPosition,
          gdprSettings: {
            required: false,
            marketing: false,
            tracking: false,
            preferences: false,
            granular: {},
          },
        };
      },
      methods: {
        handleAuthorClicked(data) {
          console.log("handleAuthorClicked!", data);
        },

        handleChangeGdpr(provider) {
          let data = { provider: provider };

          let consentGivenEvent = new CustomEvent("vodl_consent_given", {
            detail: data,
          });
          document.dispatchEvent(consentGivenEvent);

          // Also notify the iOS app, that the provider was given consent to.
          if (
            window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.native_subscription_messanger
          ) {
            window.webkit.messageHandlers.toggleMessageHandler.postMessage({
              enablePlatform: data.provider,
            });
          }
        },

        handleOpenGallery(data) {
          let externalDcxGalleryEvent = new CustomEvent(
            "vodl_open_external_dcx_gallery",
            { detail: data }
          );
          window.dispatchEvent(externalDcxGalleryEvent);
        },

        handleOpenMap(data) {
          let openExternalMapEvent = new CustomEvent("vodl_open_external_map", {
            detail: data,
          });
          window.dispatchEvent(openExternalMapEvent);
        },

        setShortenContent(shorten) {
          this.shortenContent = shorten;
        },

        setGdpr(provider) {
          let newGdpr = {};

          if ("*" === provider) {
            // Full consent with alles und scharf.
            newGdpr = {
              required: true,
              marketing: true,
              tracking: true,
              preferences: true,
            };
          } else {
            // Consent for a specific provider.
            newGdpr = JSON.parse(JSON.stringify(this.gdprSettings || {}));
            newGdpr.granular = newGdpr.granular || {};
            newGdpr.granular[provider] = true;
          }

          this.gdprSettings = newGdpr;
        },

        fetchData(postId) {
          logger.log("[tts]: fetch data for post with ID " + postId);
          fetchAudioData(postId);
        },

        onLoad(e) {
          trackGAEvent("open");
          logger.log("[tts]: load-player()", e);
        },

        onPlay() {
          trackGAEvent("play");
          logger.log("[tts]: play()");
        },

        onPause(e) {
          logger.log("[tts]: pause()", e.progress);
          switch (true) {
            case e.progress <= 5:
              trackGAEvent("0-5%");
              break;
            case e.progress <= 25:
              trackGAEvent("5-25%");
              break;
            case e.progress <= 50:
              trackGAEvent("25-50%");
              break;
            case e.progress <= 75:
              trackGAEvent("50-75%");
              break;
            case e.progress <= 95:
              trackGAEvent("75-95%");
              break;
            default:
              trackGAEvent(">95%");
          }
        },

        onInteraction(interaction) {
          document.dispatchEvent(
            new CustomEvent("vodl_interaction_clicked", {
              detail: {
                interaction,
              },
            })
          );
        },
      },
    }).mount("#vodl-external-post-content");

    document.addEventListener("vodl_activate_embed_provider", function (ev) {
      let activatedProvider = ev.detail.provider || false;
      if (!activatedProvider) {
        return;
      }

      externalArticle.setGdpr(activatedProvider);
    });

    document.addEventListener("vodl_show_full_content", function () {
      externalArticle.setShortenContent(false);

      externalArticle.interactionStats = externalArticle.interactionStats.map(
        (interaction) => {
          if (interaction.type === "text-to-speech") {
            interaction.disabled = false;
          }

          return interaction;
        }
      );

      let additionalElements = document.querySelectorAll(
        ".vodl-region-article__content[hidden]"
      );
      if (additionalElements) {
        additionalElements.forEach((elem) => {
          if (null !== elem) {
            elem.removeAttribute("hidden");
          }
        });
      }
      let externalPaywalledContentWrapper =
        document.querySelector(".paywalled-content");
      if (externalPaywalledContentWrapper) {
        externalPaywalledContentWrapper.classList.remove("hidden");
      }
    });

    document.addEventListener("vodl_show_interaction_bar", showInteractionBar);
  };

  /**
   * Show the interaction bar.
   *
   * @return {void}
   */
  const showInteractionBar = () => {
    externalArticle.displayInteractionBar = true;
  };

  /**
   * Audio-player: fetch audio data via nnp rest API.
   * If successful set source for vue instance and start playing.
   *
   * @param {int} post_id   NNP post ID of current post.
   */
  const fetchAudioData = (post_id) => {
    let service_url = "/wp-json/tts/v1/speech_service";
    let url =
      window.location.protocol +
      "//" +
      window.location.hostname +
      "/" +
      service_url;
    //    url  = 'http://nnp-vol-local.medienhaus.com/wp-json/tts/v1/speech_service';

    fetch(url + "?p=" + post_id)
      .then(function (response) {
        // The API call was successful!
        return response.json();
      })
      .then(function (data) {
        if (data.file) {
          logger.log("[tts]: fetchAudioData()", "file: " + data.file);

          // set autoplay on true by default.
          let autoplay = externalArticle.post.audio.autoplay
            ? externalArticle.post.audio.autoplay
            : true;

          // add audio source to post data.
          let audio = {
            source: data.file,
            postId: post_id,
            autoplay: autoplay,
          };
          externalArticle.post.audio = audio;
        } else {
          console.warn("[tts]:" + data.code, data.message);
        }
      })
      .catch(function (err) {
        // There was an error.
        console.warn("[tts]: " + err);
      });
  };

  /**
   * Track google analytics events.
   *
   * @param {string} action  EventAction to be tracked.
   * @param {string} cat     EventCategory (default: 'TextToSpeech').
   */
  const trackGAEvent = (action, cat = "TextToSpeech") => {
    if ("undefined" === typeof dataLayer || null === dataLayer) {
      return;
    }

    const eventData = {
      event: "genericEvent",
      eventCategory: cat,
      eventAction: action,
      eventLabel: window.location.href,
    };

    dataLayer.push(eventData);

    document.dispatchEvent(
      new CustomEvent("hansrmdtevent", { detail: eventData })
    );

    logger.log("trackGAEvent()", cat, action);
  };

  /**
   * Grab the JSON that should be provided in the page and parse it.
   *
   * @return {object|boolean} The post data object on success, false otherwise.
   */
  const parsePostData = function () {
    const postDataNode = document.querySelector("#newExternalPostDataNode");

    let parsedPostData = {};

    try {
      parsedPostData = JSON.parse(postDataNode.innerHTML) || false;
    } catch (e) {
      return false;
    }

    return parsedPostData;
  };

  /**
   * Calculates the position of the paywall.
   * If paywallPosition is 1 then it should be displayed after the first content block.
   *
   * @param  {int}   paywallPosition  Desired paywall position.
   * @param  {array} blocks           Array of content blocks.
   * @return {int}                    Actual, calculated position.
   */
  const calculatePaywallPosition = function (
    paywallPosition,
    blocks,
    contentBlocksOnly = false
  ) {
    if (contentBlocksOnly) {
      // For (VN) comments only content blocks are considered.
      // Increase paywallPosition once to show first content block as there is no explicit lead.
      logger.log("paywallPosition VN comment: " + (paywallPosition + 1));
      return paywallPosition + 1;
    }

    let visibleBlocks = blocks.filter(function (block, index) {
      if ("Author" === block.t || "CommentAuthor" === block.t) {
        return true;
      }

      let content = block.h;
      if (content.match(/russmedia-nordstern-lead/i)) {
        return true;
      }

      if (content.match(/wp-block-image/i) && 0 === index) {
        return true;
      }

      return false;
    });

    logger.log("paywallPosition: " + (visibleBlocks.length + paywallPosition));
    return visibleBlocks.length + paywallPosition;
  };

  window.RussMedia = window.RussMedia || {};
  window.RussMedia.Consent = window.RussMedia.Consent || {};
  window.RussMedia.Consent.Embeds = window.RussMedia.Consent.Embeds || {};
  window.RussMedia.Consent.Embeds.UI = {
    activateEmbedProvider: function () {
      document.dispatchEvent(
        new CustomEvent("vodl_activate_embed_provider", {
          detail: { provider: "*" },
        })
      );
    },
  };
  _init();
})(window, document);
